<template>
    <div
        class="artwork-option"
        :class="{ 'selected': isSelected }"
        @click="$emit('select')"
    >
        <slot>
            <div class="artwork">
                <artwork-file-preview :file="file" />
            </div>
        </slot>

        <span class="artwork-label">{{ label }}</span>
    </div>
</template>
<script>
import ArtworkFilePreview from './ArtworkFilePreview';

export default {
    components: {
        ArtworkFilePreview,
    },

    props: {
        isSelected: {
            default: false,
            type: Boolean,
        },

        label: {
            required: true,
            type: String,
        },

        file: {
            default: null,
            type: [String, File],
        },
    },
};
</script>
